import { useEffect, useState } from "react";
import styles from "./PopupProduct.module.css";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../../lib/get-image";
import { IoClose } from "react-icons/io5";

const ProductPopup = ({ products = [] }) => {

  const [currentIndex, setCurrentIndex] = useState(0);

  // ✅ hide/show popup
  const [showPopup, setShowPopup] = useState(true);

  useEffect(() => {
    if (!products.length) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === products.length - 1 ? 0 : prev + 1
      );
    }, 4000);

    return () => clearInterval(interval);
  }, [products]);

  // ❌ if closed
  if (!showPopup) return null;

  if (!products.length) return null;

  const product = products[currentIndex];

  return (
    <div className={styles.popupWrapper}>

      {/* ❌ CLOSE BUTTON */}
      <button
        className={styles.closeBtn}
        onClick={() => setShowPopup(false)}
      >
        <IoClose />
      </button>

      <Link
        to={`/productdetails/${product.slug}`}
        className={styles.popup}
      >
        <img
          src={getImageUrl(product.thumb_image)}
          alt={product.name}
          className={styles.image}
        />

        <div className={styles.content}>
          {/* <p className={styles.text}>
            Someone purchased
          </p> */}

          <h4 className={styles.name}>
            {product.name}
          </h4>

          <p className={styles.price}>
            Rs.{product.offer_price || product.price}.00
          </p>
        </div>
      </Link>

    </div>
  );
};

export default ProductPopup;